<template>
  <div class="dropdown-wrapper">
    <div class="dropdown-action" @click="$emit('action2'); closeDropdown()">
      <span class="dropdown-action-text">Dropdown action 1</span>
    </div>
    <div class="dropdown-action" @click="$emit('action2'); closeDropdown()">
      <span class="dropdown-action-text" >Dropdown action 2</span>
    </div>
    <div class="dropdown-action" @click="$emit('action3'); closeDropdown()">
      <span class="dropdown-action-text">Dropdown action 3</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "KpiDropdownComponent",
  props: {
    closeDropdown: Function
  }
}
</script>

<style scoped lang="scss">
.dropdown-wrapper {
  width: 100%;

  .dropdown-action {
    border-bottom: 1px solid map-get($grey, 'lighten-blue-1');
    display: block;
    cursor: pointer;
    font-size: 14px;
    padding: 16px;
    transition: all 0.2s ease-in-out;;
    width: 100%;

    &:last-child {
      border: none;
    }

    &:hover {
      background-color: map-get($green, 'lighten-5');
      color: map-get($grey, 'dark');
    }

    .dropdown-action-text {
      margin: auto;
    }
  }
}
</style>
